<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            FINANCE / Reconciliations
          </div>
          <el-table
              size="mini"
              max-height="600"
              :data="tableData"
              :empty-text="$t('general_noData')"
              :header-cell-class-name="headerCellClassName"
              style="width: 100%"
              @cell-click="cellClick">
            <el-table-column
                align="center"
                column-key="fromTF"
                label="Chart of Accounts (CoA)">
              <el-table-column
                  width="100"
                  align="center"
                  prop="code"
                  column-key="fromTF"
                  label="DB Code">
                <template slot-scope="scope">
                  <div>
                    {{scope.row.code}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  column-key="fromTF"
                  label="Sub-accounts">
                <template slot-scope="scope">
                  <div style="color: #409EFF; cursor: pointer;">{{scope.row.name}}</div>
                </template>
              </el-table-column>
              <el-table-column
                  column-key="fromTF"
                  class-name="sub-accounts"
                  label="Status">
                <template slot-scope="scope">
                  <span style="color: #409EFF;">
                    {{scope.row.close ? 'Closed' : scope.row.active ? 'Active' : 'Inactive' }}
                  </span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
                align="center"
                label="Reconciliation Information">
              <el-table-column
                  width="160"
                  align="center"
                  prop="bankAccount.accountNumber"
                  label="Bank Account Number">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{scope.row.bankAccount.accountNumber}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  width="150"
                  label="Last Date Reconciled">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  width="190"
                  align="center"
                  label="Due Date for Reconciliation">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  align="center"
                  prop="bankAccount.buName"
                  label="Business Unit">
                <template slot-scope="scope">
                  <div>
                    {{scope.row.bankAccount.buName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  align="center"
                  prop="bankAccount.buUserName"
                  label="User">
                <template slot-scope="scope">
                  <div>
                    {{scope.row.bankAccount.buUserName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  align="center"
                  label="Action">
                <template slot-scope="scope">
                  <el-button size="mini" plain>Reconcile</el-button>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
                align="center"
                column-key="fromTF"
                label="General Ledger (GL)">
              <el-table-column
                  align="center"
                  width="200"
                  column-key="fromTF"
                  label="Current Balance (Dr)">
                <template slot-scope="scope">
                  <div style="text-align: right; color: #409EFF; cursor: pointer;" class="number">{{scope.row.currentBalance ? formatPrice(scope.row.currentBalance) : formatPrice(0)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <bank-account-transaction-modal ref="bankAccountTransactionModal"/>
    <settings-bank-account-info-modal
        ref="settingBankAccountInfoModal"/>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import SettingsBankAccountInfoModal
  from "../../../components/settings/settingsBankAccounts/settingsBankAccountInfoModal";
import BankAccountTransactionModal from "../../../components/settings/settingsBankAccounts/BankAccountTransactionModal";

export default {
  name: "Reconciliations",
  components: {BankAccountTransactionModal, SettingsBankAccountInfoModal},
  data(){
    return {
      tableData: [],
      moment: moment
    }
  },
  mounted(){
    this.loadList()
  },
  methods: {
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/account/accountOnlyBank?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    // rowClick(row, column, event) {
    //   if (column.columnKey !== 'action') {
    //     this.$refs.settingBankAccountInfoModal.openModal(row)
    //   }
    // },
    cellClick(row, column, event) {
      if (column.label === 'Current Balance (Dr)') {
        this.$refs.bankAccountTransactionModal.openModal(row)
      } else if (column.label === 'Sub-accounts') {
        this.$refs.settingBankAccountInfoModal.openModal(row)
      }
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    headerCellClassName({row, column, rowIndex, columnIndex}) {
      console.log('{row, column, rowIndex, columnIndex}', {row, column, rowIndex, columnIndex})
      return column.columnKey
    }
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        text-align: left;
        justify-content: flex-start;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

/deep/.fromTF {
  background: #e7adb7 !important;
  color: black;
}
</style>
